/*
================================================================================
  KIT LAINE — refus du panier, rendu visible
  Version 1.0 — passe 58
================================================================================

  À poser dans le thème sous assets/lat-kit-panier.js, à côté de
  snippets/lat-kit-panier.liquid qui le charge. Voir l'en-tête du snippet
  pour l'installation, et docs/02-deploiement.md § A5ter.

  CE QU'IL FAIT

  Quand Shopify refuse une modification du panier, il répond 422 avec un
  texte destiné au client — celui de la règle au paiement, « … se vend avec
  sa laine », mais aussi un stock dépassé. Le thème décide seul de le
  montrer, et Symmetry ne le montre pas : essayé le 28/09/2026, retirer la
  dernière laine d'un kit ne faisait simplement rien. Ce script affiche ce
  texte dans un bandeau.

  Il écoute, sans rien y changer, les requêtes que le thème envoie au
  panier — par `fetch` comme par `XMLHttpRequest`, tous les thèmes
  n'utilisant pas le même. Seules comptent les MODIFICATIONS : un POST vers
  /cart/change ou /cart/update, avec ou sans `.js`, préfixe de langue
  compris.

  Il écoute aussi la LECTURE des réponses à ces adresses, pour les apps
  qui modifient le panier elles-mêmes avec une copie de `fetch` prise
  avant ce script : Easy Flow Product Options le fait sur la boutique de
  production. Voir « L'écoute : la lecture de la réponse », plus bas.

  - Un 422 portant un texte ouvre le bandeau, ou en remplace le texte.
  - Une modification réussie le referme : le panier est redevenu valide.

  Les AJOUTS (/cart/add) restent au thème. Un thème montre en général ses
  erreurs d'ajout sous le bouton, parce qu'un stock épuisé y est courant :
  Symmetry le fait, et le bloc vitrine aussi. Les surveiller aussi aurait
  affiché chaque refus deux fois.

  La réponse n'est lue que sur une COPIE (`clone()`), prise avant que le
  thème ne lise l'originale : le thème reçoit exactement ce qu'il aurait
  reçu sans ce script.

  LA PAGE RECHARGÉE

  Après une modification refusée, Symmetry recharge la page — « Uncertainty…
  Reload page », dit son code. Le bandeau s'ouvrait donc un dixième de
  seconde, puis disparaissait avec elle. Un refus encore frais quand la
  page se décharge est donc confié à la mémoire de session du navigateur,
  et la page suivante l'affiche dès son chargement, puis l'oublie.

  LA FEUILLE DE STYLE

  Le bandeau porte la classe `lat-kit`, donc les couleurs de la palette
  du bloc, et son style vit dans lat-kit-laine.css. Cette feuille n'est
  chargée qu'au premier refus — elle l'est déjà sur une fiche modèle —,
  et le bandeau reste caché jusqu'à ce qu'elle le soit : sans elle, il
  s'afficherait sans mise en forme au bas de la page.

  LIMITES

  - Tous les refus de modification s'affichent, pas seulement ceux de la
    règle : un stock dépassé aussi. Un thème qui montre déjà les siens les
    montrera en double.
  - Le thème reçoit sa réponse quelques millisecondes plus tard, le temps
    de lire la copie : c'est ce qui permet de survivre à un rechargement.
  - Une app qui garde sa propre copie de `fetch` n'est vue que si elle
    LIT la réponse. Easy Flow la lit ; une app qui ne la lirait pas, ou qui
    passerait par un autre cadre de page, resterait muette.

  ES5 strict, sans double accolade littérale : mêmes contraintes que le
  script du bloc, et pour les mêmes raisons (CLAUDE.md § Contraintes).
================================================================================
*/
(function () {
  'use strict';

  /* Posé deux fois — deux blocs « Liquid personnalisé », un rechargement
     de section dans l'éditeur —, il ne doit écouter qu'une fois : sinon
     chaque refus ouvrirait autant de bandeaux. */
  if (window.latKitPanier) return;
  window.latKitPanier = true;

  var MODIFICATION = /\/cart\/(change|update)(\.js)?$/;

  /* Un refus survit au déchargement de la page s'il date de moins de
     FRAIS, et s'affiche sur la suivante si elle arrive dans les DUREE. Le
     premier couvre la réponse d'un thème qui recharge aussitôt ; le second,
     un rechargement lent sur mobile. */
  var CLE = 'lat-kit-panier';
  var FRAIS = 5000;
  var DUREE = 20000;

  /* Le libellé du bouton de fermeture, pour les lecteurs d'écran. Trois
     mots ne justifient pas trois clés de locale de plus à tenir d'accord
     dans quatre sources (CLAUDE.md § Contraintes, point 4) : la langue de
     la page suffit, et l'anglais couvre le reste. */
  var FERMER = { fr: 'Fermer', en: 'Close', is: 'Loka' };

  var script = document.querySelector('script[data-lat-kit-panier]');
  var urlFeuille = script ? script.getAttribute('data-feuille') : '';

  /**
   * Une requête du thème qui modifie le panier ?
   */
  function surveillee(url, methode) {
    return String(methode || 'GET').toUpperCase() === 'POST' && modifie(url);
  }

  /**
   * Une adresse qui modifie le panier ? Seule question qu'on puisse poser à
   * une réponse, qui ne dit pas sa méthode : l'adresse suffit, un GET sur
   * /cart/change modifiant le panier lui aussi.
   */
  function modifie(url) {
    var chemin = String(url || '').split('#')[0].split('?')[0];
    return MODIFICATION.test(chemin);
  }

  function texteDe(reponse) {
    if (!reponse || typeof reponse !== 'object') return '';
    var t = reponse.description || reponse.message;
    return typeof t === 'string' ? t : '';
  }

  /* ---- La feuille, chargée au premier refus ---- */

  var etatFeuille = '';        // '', 'charge', 'prete'
  var enAttente = [];

  function feuilleDejaLa() {
    var liens = document.querySelectorAll('link[rel="stylesheet"]');
    for (var i = 0; i < liens.length; i++) {
      if ((liens[i].getAttribute('href') || '').indexOf('lat-kit-laine') !== -1) return true;
    }
    return false;
  }

  function avecFeuille(ensuite) {
    /* En cours de chargement, on attend — et avant tout le reste : le
       <link> qu'on vient de poser porte lui aussi « lat-kit-laine », et
       feuilleDejaLa() le prendrait pour une feuille prête. Un second refus
       pendant le chargement s'affichait alors sans style (passe 58). */
    if (etatFeuille === 'charge') { enAttente.push(ensuite); return; }
    if (etatFeuille === 'prete' || !urlFeuille || feuilleDejaLa()) {
      etatFeuille = 'prete';
      ensuite();
      return;
    }
    enAttente.push(ensuite);
    etatFeuille = 'charge';

    var lien = document.createElement('link');
    lien.setAttribute('rel', 'stylesheet');
    lien.setAttribute('href', urlFeuille);
    var fini = false;
    function prete() {
      if (fini) return;
      fini = true;
      etatFeuille = 'prete';
      var liste = enAttente;
      enAttente = [];
      liste.forEach(function (f) { f(); });
    }
    /* Une feuille en erreur ne doit pas taire le refus : mieux vaut un
       bandeau sans style qu'aucun message. Même chose si le navigateur
       ne signale jamais le chargement. */
    lien.addEventListener('load', prete);
    lien.addEventListener('error', prete);
    window.setTimeout(prete, 3000);
    (document.head || document.body).appendChild(lien);
  }

  /* ---- Le bandeau ---- */

  var bandeau = null;
  var texte = null;
  var dernier = '';
  var dernierQuand = 0;

  function langue() {
    var l = (document.documentElement.getAttribute('lang') || '').slice(0, 2).toLowerCase();
    return FERMER[l] ? l : 'en';
  }

  function construire() {
    bandeau = document.createElement('div');
    bandeau.setAttribute('class', 'lat-kit lat-kit-panier');
    bandeau.setAttribute('role', 'alert');
    bandeau.setAttribute('hidden', '');

    texte = document.createElement('p');
    texte.setAttribute('class', 'lat-kit-panier__texte');
    bandeau.appendChild(texte);

    var fermer = document.createElement('button');
    fermer.setAttribute('type', 'button');
    fermer.setAttribute('class', 'lat-kit-panier__fermer');
    fermer.setAttribute('aria-label', FERMER[langue()]);
    fermer.textContent = '×';
    fermer.addEventListener('click', masquer);
    bandeau.appendChild(fermer);

    document.body.appendChild(bandeau);
  }

  function afficher(message) {
    if (!message) return;
    dernier = message;
    dernierQuand = new Date().getTime();
    avecFeuille(function () {
      /* Un refus plus récent a pu passer entre-temps : on montre le
         dernier. Un succès, lui, a vidé `dernier`. */
      if (!dernier) return;
      if (!bandeau || !document.body.contains(bandeau)) construire();
      texte.textContent = dernier;
      bandeau.removeAttribute('hidden');
    });
  }

  function masquer() {
    dernier = '';
    if (bandeau) bandeau.setAttribute('hidden', '');
  }

  /* ---- La page rechargée ----
     Tout accès à la mémoire de session est gardé : elle peut manquer, ou
     lever une erreur en navigation privée. Sans elle, on retombe sur le
     comportement d'avant — le bandeau disparaît avec la page. */

  function memoire() {
    try { return window.sessionStorage || null; } catch (e) { return null; }
  }

  window.addEventListener('pagehide', function () {
    var m = memoire();
    if (!m || !dernier || new Date().getTime() - dernierQuand > FRAIS) return;
    try {
      m.setItem(CLE, JSON.stringify({ message: dernier, quand: dernierQuand }));
    } catch (e) { /* mémoire pleine ou refusée : tant pis */ }
  });

  (function reprendre() {
    var m = memoire();
    if (!m) return;
    var retenu = null;
    try {
      retenu = JSON.parse(m.getItem(CLE) || 'null');
      m.removeItem(CLE);
    } catch (e) { return; }
    if (!retenu || typeof retenu.message !== 'string' || typeof retenu.quand !== 'number') return;
    if (new Date().getTime() - retenu.quand > DUREE) return;
    afficher(retenu.message);
    /* Un refus repris n'est jamais retenu une seconde fois : sans quoi il
       suivrait le client de page en page tant qu'il navigue vite. */
    dernierQuand = 0;
  })();

  /* ---- L'écoute : fetch ---- */

  if (typeof window.fetch === 'function') {
    var fetchOrigine = window.fetch;
    window.fetch = function (ressource, options) {
      var promesse = fetchOrigine.apply(window, arguments);
      var estRequete = ressource && typeof ressource === 'object';
      var url = estRequete ? ressource.url : ressource;
      var methode = (options && options.method) || (estRequete ? ressource.method : '');

      if (!surveillee(url, methode)) return promesse;

      /* Le thème reçoit la MÊME réponse, intacte, mais seulement une fois
         sa copie lue. Sans cette attente, un thème qui recharge la page
         aussitôt — Symmetry — la déchargeait avant que le message ne soit
         connu : essayé dans Chromium, le refus se perdait. La copie est
         prise avant que le thème ne touche à l'originale, et une copie
         illisible ne retient rien : la réponse part telle quelle. Un échec
         réseau passe au thème sans détour. */
      return promesse.then(function (reponse) {
        if (reponse.ok) { masquer(); return reponse; }
        if (reponse.status !== 422 || typeof reponse.clone !== 'function') return reponse;
        return reponse.clone().json().then(function (j) {
          afficher(texteDe(j));
          return reponse;
        }, function () { return reponse; });
      });
    };
  }

  /* ---- L'écoute : XMLHttpRequest ---- */

  var XHR = window.XMLHttpRequest;
  if (XHR && XHR.prototype) {
    var ouvrir = XHR.prototype.open;
    var envoyer = XHR.prototype.send;

    XHR.prototype.open = function (methode, url) {
      this.latKitRequete = { methode: methode, url: url };
      return ouvrir.apply(this, arguments);
    };

    XHR.prototype.send = function () {
      var xhr = this;
      var r = xhr.latKitRequete;
      if (r && surveillee(r.url, r.methode)) {
        xhr.addEventListener('load', function () {
          if (xhr.status >= 200 && xhr.status < 300) { masquer(); return; }
          if (xhr.status !== 422) return;
          try {
            afficher(texteDe(xhr.responseType === 'json' ? xhr.response : JSON.parse(xhr.responseText)));
          } catch (e) { /* réponse illisible : rien à affirmer */ }
        });
      }
      return envoyer.apply(this, arguments);
    };
  }

  /* ---- L'écoute : la lecture de la réponse ----
     Relevé le 28/09/2026 sur la boutique de production : le refus
     bloquait, aucun bandeau. Easy Flow Product Options y capte le clic sur
     « Supprimer » avant Symmetry, envoie lui-même la suppression avec la
     copie de `fetch` qu'il a prise en se chargeant — avant ce script —,
     lit la réponse, puis recharge la page. Ni l'écoute de `fetch` ni celle
     de XMLHttpRequest ne voyaient rien passer.

     Quelle que soit la copie de `fetch` qui l'a obtenue, une réponse se lit
     par les méthodes communes à toutes les réponses de la page : c'est là
     qu'on la rattrape. Le thème ou l'app reçoit exactement ce qu'il aurait
     lu — même valeur, même échec —, et le bandeau apprend le refus avant
     que la page ne se recharge.

     Une réponse lue deux fois — par l'écoute de `fetch`, puis par le
     thème — passe deux fois ici : sans effet, le texte est le même. */

  var Reponse = window.Response;
  if (Reponse && Reponse.prototype) {
    ['json', 'text'].forEach(function (nom) {
      var lireOrigine = Reponse.prototype[nom];
      if (typeof lireOrigine !== 'function') return;

      Reponse.prototype[nom] = function () {
        var reponse = this;
        var promesse = lireOrigine.apply(this, arguments);
        var url = '';
        try { url = reponse.url; } catch (e) { return promesse; }
        if (!modifie(url)) return promesse;

        return promesse.then(function (lu) {
          var corps = lu;
          if (nom === 'text') {
            try { corps = JSON.parse(lu); } catch (e) { corps = null; }
          }
          /* Rien de ce qui arrive au bandeau ne doit changer ce que
             reçoit celui qui lit. */
          try {
            if (reponse.status >= 200 && reponse.status < 300) masquer();
            else if (reponse.status === 422) afficher(texteDe(corps));
          } catch (e) { /* le bandeau se tait, la lecture suit son cours */ }
          return lu;
        });
      };
    });
  }
})();
